import {
  KeyboardDoubleArrowLeft,
  KeyboardDoubleArrowRight,
  Search
} from "@mui/icons-material";
import { Grid, InputAdornment, Tooltip } from "@mui/material";
import { Field } from "formik";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
// import { FontSize, Appcolors } from "../../../const";
// import { MyButton, MySelect, MyTextField } from "../CapPhepVaDoiTuong/componentLibrarys";
// import Api from "../../../api";
import { MySelect, MyTextField } from "../MapLibrary";
import FontSize from "../../../constants/fontSize";
import Appcolors from "../../../constants/colors";
import Api from "../../../api2";
import { isEmpty } from "lodash";

export function FormFilter(props) {
  const {
    propsForm,
    required,
    handleFormikChange,
    onSubmitAPI,
    onSubmitSearch
  } = props;
  const [searchParams, setSearchParams] = useSearchParams();
  const [tinhThanhList, setTinhThanhList] = useState([]);
  const [quanHuyenList, setQuanHuyenList] = useState([]);
  const [phuongXaList, setPhuongXaList] = useState([]);
  const [openSearchDetail, setOpenSearchDetail] = useState();

  useEffect(() => {
    // getApi_Huyen()
    const { doiTuongTimKiem, search } = Object.fromEntries(
      searchParams.entries()
    );
  }, [searchParams]);
  
  const getApiListDvhc = (cap, madvhc, setData) => {
    new Api()
      .GetListDvhc({ cap: cap, madvhc: madvhc })
      .then(data => {
        if (data.code === 200) {
          setData(data?.data?.result);
        }
      })
      .catch(err => {})
      .finally(() => {});
  };
  
  const onKeyDown = e => {
    if (e.key === "Enter") {
      onSubmitSearch(propsForm?.values);
    }
  };

  const AdvancedSearch = (
    <Grid
      container
      columnSpacing={2}
      style={{ marginTop: "5px", display: "flex", flexWrap: "nowrap" }}
    >
      <Grid item xs={4}>
        <MySelect
          placeholder="Tỉnh thành"
          value={propsForm?.values?.tinhThanh}
          options={tinhThanhList}
          name="tenDVHC"
          onChange={(event, value) => {
            propsForm?.setFieldValue(`tinhThanh`, value);
            propsForm?.setFieldValue(`quanHuyen`, null);
            propsForm?.setFieldValue(`phuongXa`, null);
          }}
          onOpen={() => {
            isEmpty(tinhThanhList) && getApiListDvhc(1, "", setTinhThanhList);
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <MySelect
          placeholder="Quận huyện"
          value={propsForm?.values?.quanHuyen}
          options={quanHuyenList || []}
          name="tenDVHC"
          onChange={(event, value) => {
            propsForm?.setFieldValue(`quanHuyen`, value);
            propsForm?.setFieldValue(`phuongXa`, null);
          }}
          onOpen={() => {
            propsForm?.values?.tinhThanh?.maTinh &&
              getApiListDvhc(2, propsForm?.values.tinhThanh.maTinh, setQuanHuyenList);
          }}
        />
      </Grid>
      <Grid item xs={4}>
        <MySelect
          placeholder="Phường xã"
          value={propsForm?.values?.phuongXa}
          options={phuongXaList || []}
          name="tenDVHC"
          onChange={(event, value) => {
            propsForm?.setFieldValue(`phuongXa`, value);
          }}
          onOpen={() => {
            propsForm?.values?.quanHuyen?.maHuyen &&
              getApiListDvhc(3, propsForm?.values.quanHuyen.maHuyen, setPhuongXaList);
          }}
        />
      </Grid>
      {/* <Grid item xs={3}>
        <MySelect
          placeholder="Đối tượng kiểm kê"
          value={propsForm?.values?.doiTuongTimKiem}
          options={[]}
          name="tenMuc"
          onChange={(event, value) => {
            propsForm.setFieldValue(`doiTuongTimKiem`, value);
          }}
        />
      </Grid> */}
      <Tooltip title="Thu gọn">
        <KeyboardDoubleArrowLeft
          style={{
            cursor: "pointer",
            margin: "1px 0px 0px 1px",
            width: 30,
            height: 30,
            backgroundColor: "#ffffff82"
          }}
          onClick={() => {
            setOpenSearchDetail(false);
          }}
        />
      </Tooltip>
    </Grid>
  );

  return (
    <>
      <Grid item style={{ width: "100%" }}>
        <Field name="search">
          {({ field }) => (
            <MyTextField
              placeholder="Thông tin tìm kiếm..."
              onKeyDown={onKeyDown}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <Search
                      sx={{ fontSize: "20px", cursor: "pointer" }}
                      type="submit"
                      onClick={() => {
                        onSubmitSearch(propsForm?.values);
                      }}
                    />
                  </InputAdornment>
                ),
                sx: {
                  backgroundColor: "white",
                  height: "33px !important",
                  color: Appcolors.textFiled,
                  fontSize: FontSize.textField,
                  "& .MuiOutlinedInput-input": {
                    textOverflow: "ellipsis"
                  },
                  "& .MuiOutlinedInput-input.Mui-disabled": {
                    WebkitTextFillColor: Appcolors.textFiledDisabled
                  }
                }
              }}
              {...field}
            />
          )}
        </Field>
      </Grid>
      {!openSearchDetail ? (
        <Tooltip title="Tìm kiếm nâng cao">
          <KeyboardDoubleArrowRight
            style={{
              cursor: "pointer",
              margin: "3px 0px 0px 1px",
              width: 30,
              height: 30,
              backgroundColor: "#ffffff82"
            }}
            onClick={() => {
              setOpenSearchDetail(true);
            }}
          />
        </Tooltip>
      ) : (
        AdvancedSearch
      )}
    </>
  );
}
